import React, { ReactNode, useState } from 'react';
import { FdsChevron } from '../../../components/common/chevron/fds-chevron';
import { Breadcrumbs, ViewBanner } from '../../../components/sections';
import { useSearchContent } from '../../../components/sections/search-bar/hooks/use-search-content';
import SearchBarInput from '../../../components/sections/search-bar/search-bar-input/search-bar-input';
import './breadcrumbs-and-view-banner.scss';
import OwnerManualAiSearch from '../owner-manual-ai-search/owner-manual-ai-search';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';

interface Props {
    currentPage: string;
    previousCrumb?: ReactNode;
    hashId: string;
    bbtTitle?: string;
    bbtSubtitle?: string;
    searchTerm?: string;
    isCatPage?: boolean;
    searchClassName?: string;
    isAiSearch?: boolean;
    aiSearchContent?: OwnerManualProps;
}

const BreadcrumbsAndViewBanner = (props: Props) => {
    const searchContent = useSearchContent();
    const [breadcrumbToggle, setBreadCrumbToggle] = useState<boolean>(false);
    return (
        <>
            <div
                className={`breadcrumbAccordion ${breadcrumbToggle &&
                    'expanded'}`}
                data-testid="breadcrumbs-and-view-banner"
            >
                <Breadcrumbs
                    currentPage={props.currentPage}
                    hashId={props.hashId}
                >
                    {props.previousCrumb}
                </Breadcrumbs>
                <div
                    data-testid="chevronToggle"
                    onClick={() => setBreadCrumbToggle(!breadcrumbToggle)}
                >
                    <FdsChevron
                        direction={breadcrumbToggle ? 'up' : 'down'}
                        type={'unfilled'}
                    ></FdsChevron>
                </div>
            </div>
            {props.isAiSearch &&
            props.aiSearchContent &&
            props.aiSearchContent.aiSearchTitle ? (
                <OwnerManualAiSearch aiSearchContent={props.aiSearchContent} />
            ) : (
                <>
                    {searchContent && (
                        <div
                            className={
                                props.searchClassName || 'sh-view-banner'
                            }
                        >
                            <ViewBanner
                                topComponent={
                                    props.isCatPage ? (
                                        <div className="title">
                                            <h1 className="bbt-title">
                                                {props.bbtTitle}
                                            </h1>

                                            <p className="choose-your-category">
                                                {props.bbtSubtitle}
                                            </p>
                                        </div>
                                    ) : (
                                        <SearchBarInput
                                            hideSearchBarTitle={true}
                                            searchContent={searchContent}
                                            searchTerm={props.searchTerm}
                                        />
                                    )
                                }
                                backgroundImageDesktop={
                                    process.env.REACT_APP_AEM_BASE_URL +
                                    searchContent.searchBackgroundImageDesktop
                                }
                                backgroundImageMobile={
                                    process.env.REACT_APP_AEM_BASE_URL +
                                    searchContent.searchBackgroundImageMobile
                                }
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default BreadcrumbsAndViewBanner;
